export const getGraceType = [
  { id: 'NO_GRACE_PERIOD', value: 0, name: 'Sin período de gracia' },
  {
    id: 'ZERO_GRACE',
    value: 1,
    name: 'Sin pago de interés ni capital.',
  },
  {
    id: 'INTEREST',
    value: 2,
    name: 'Paga interés sin capital.',
  },
  {
    id: 'ACCUMULATED',
    value: 3,
    name:
      'Paga interés y capital en primera cuota después de período de gracia',
  },
];
